import React from "react";
import Work from "../Components/Work";
import { personalDetails, workDetails, eduDetails } from "../Details";

/* Professional hover style for section headings */
const sectionHeadingClass = `
  relative inline-block
  transition-all duration-300
  hover:text-purple-400
  after:absolute after:left-0 after:-bottom-2
  after:h-[3px] after:w-0 after:bg-purple-500
  after:transition-all after:duration-300
  hover:after:w-full
`;

function About() {
  return (
    <main className="container mx-auto max-width pt-10 pb-20">

      {/* ABOUT ME */}
      <section>
        <h1
          className={`text-2xl text-white 
          md:text-4xl xl:text-5xl xl:leading-tight font-bold ${sectionHeadingClass}`}
        >
          About Me
        </h1>

        {/* About text */}
        <div className="leading-relaxed lg:max-w-3xl space-y-4 text-white mt-6">
          {personalDetails.about
            .split(". ")
            .reduce((acc, sentence, index, array) => {
              if (index % 2 === 0) {
                acc.push(
                  (sentence.endsWith(".") ? sentence : sentence + ".") +
                    " " +
                    (array[index + 1]
                      ? array[index + 1].endsWith(".")
                        ? array[index + 1]
                        : array[index + 1] + "."
                      : "")
                );
              }
              return acc;
            }, [])
            .map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
        </div>

        {/* Download CV Button */}
        <div className="mt-8">
          <a
            href="/Shagun_Dave_DevOps_Consultant_CV.pdf"
            download
            className="inline-flex items-center gap-2 px-6 py-3 
                       text-white font-semibold rounded-md
                       bg-purple-600 hover:bg-purple-700
                       transition-all duration-300
                       shadow-md hover:shadow-lg hover:-translate-y-0.5"
          >
            {/* Download icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
              />
            </svg>
            Download CV
          </a>
        </div>
      </section>

      {/* WORK EXPERIENCE */}
      <section className="mt-12">
        <h1
          className={`text-2xl text-white 
          md:text-4xl xl:text-5xl xl:leading-tight font-bold ${sectionHeadingClass}`}
        >
          Work Experience
        </h1>

        {React.Children.toArray(
          workDetails.map(({ Position, Company, Location, Type, Duration }) => (
            <Work
              position={Position}
              company={Company}
              location={Location}
              type={Type}
              duration={Duration}
            />
          ))
        )}
      </section>

      {/* EDUCATION */}
      <section className="mt-12">
        <h1
          className={`text-2xl text-white 
          md:text-4xl xl:text-5xl xl:leading-tight font-bold ${sectionHeadingClass}`}
        >
          Education
        </h1>

        {React.Children.toArray(
          eduDetails.map(({ Position, Company, Location, Type, Duration }) => (
            <Work
              position={Position}
              company={Company}
              location={Location}
              type={Type}
              duration={Duration}
            />
          ))
        )}
      </section>

    </main>
  );
}

export default About;
